import styled from 'styled-components';

import { colors } from '../../../../utils/utils';

const Item = styled.div<{ $enabled?: boolean }>`
    width: 100%;

    padding: 8px 24px;

    color: ${colors.gray.dark};

    font-size: 14px;
    font-weight: 600;

    transition: color 0.25s ease;

    user-select: none;

    cursor: ${props => (props.$enabled === false ? 'default' : 'pointer')};

    ${props =>
        props.$enabled === false &&
        `
        pointer-events: none;
        touch-action: none;
        opacity: 0.5;
    `} &:hover, &:hover a {
        color: ${colors.blue.palatinate_blue};
    }
`;

export default Item;
